import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { priceFormatter } from 'utils/formatters';
import { PURCHASED_AT_FORMAT } from 'enums/date-format-enums';
import { ORDER_STATES } from 'enums/order-state-enums';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const ExpandedRowContent = ({ order }) => {
  const day = moment(order.purchasedAt).format(PURCHASED_AT_FORMAT);
  const price = priceFormatter(order.priceCents);
  const reason = order.sellerCanceledReason ? order.sellerCanceledReason.split(':') : null;
  return (
    <ExpandedRowContent.StyledExpandedRowContent>
      <ExpandedRowContent.OrderDetails>
        <ExpandedRowContent.Details>
          <ExpandedRowContent.Header>order #</ExpandedRowContent.Header>
          <ExpandedRowContent.Value>{order.number}</ExpandedRowContent.Value>
        </ExpandedRowContent.Details>
        <ExpandedRowContent.Details>
          <ExpandedRowContent.Header>order date</ExpandedRowContent.Header>
          <ExpandedRowContent.Value>{day}</ExpandedRowContent.Value>
        </ExpandedRowContent.Details>
        <ExpandedRowContent.Details>
          <ExpandedRowContent.Header>sold price</ExpandedRowContent.Header>
          <ExpandedRowContent.SoldPrice
            isCanceled={
              order.status === ORDER_STATES.canceled_by_seller_review.value ||
              order.status === ORDER_STATES.canceled_by_seller.value ||
              order.status === ORDER_STATES.canceled_by_buyer.value
            }
            isReturned={order.status === ORDER_STATES.buyer_return_approved.value}
          >
            ${price}
          </ExpandedRowContent.SoldPrice>
        </ExpandedRowContent.Details>
      </ExpandedRowContent.OrderDetails>
      {(order.status === ORDER_STATES.canceled_by_seller_review.value ||
        order.status === ORDER_STATES.canceled_by_seller.value ||
        order.status === ORDER_STATES.canceled_by_buyer.value) && (
        <ExpandedRowContent.CancelInfoContainer>
          <ExpandedRowContent.ReasonHeader>
            reasons for cancellation
          </ExpandedRowContent.ReasonHeader>
          <ExpandedRowContent.Reason>{reason && (reason[0] || 'N/A')}</ExpandedRowContent.Reason>
          <ExpandedRowContent.ReasonHeader>NOTES</ExpandedRowContent.ReasonHeader>
          <ExpandedRowContent.Reason>{reason && (reason[1] || 'N/A')}</ExpandedRowContent.Reason>
        </ExpandedRowContent.CancelInfoContainer>
      )}
    </ExpandedRowContent.StyledExpandedRowContent>
  );
};

ExpandedRowContent.StyledExpandedRowContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

ExpandedRowContent.OrderDetails = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
`;

ExpandedRowContent.Details = styled.div`
  width: 80%;
  border-top: 1px solid ${COLORS.primaryExpandedRowBorder};
  padding-top: 33px;
  display: flex;
  flex-direction: column;
`;

ExpandedRowContent.Header = styled.span`
  font-family: ${FONTS.default};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  color: ${COLORS.secondaryText};
`;

ExpandedRowContent.Value = styled.span`
  font-family: ${FONTS.default};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: ${COLORS.primaryText};
`;

ExpandedRowContent.SoldPrice = styled.span`
  font-family: ${FONTS.special};
  font-size: 20px;
  line-height: 20px;
  color: ${(props) =>
    props.isCanceled || props.isReturned ? COLORS.primaryErrorText : COLORS.primaryText};
`;

ExpandedRowContent.CancelInfoContainer = styled.div`
  border: 1px solid ${COLORS.primaryExpandedRowBorder};
  display: flex;
  flex-direction: column;
  padding: 24px 24px;
  width: 80%;
  margin-top: 34px;
  margin-bottom: 34px;
`;

ExpandedRowContent.ReasonHeader = styled.span`
  font-family: ${FONTS.default};
  color: ${COLORS.secondaryText};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
`;

ExpandedRowContent.Reason = styled.span`
  font-family: ${FONTS.default};
  color: ${COLORS.primaryText};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  top: 8px;
  margin-bottom: 24px;
`;

ExpandedRowContent.propTypes = {
  order: PropTypes.shape({
    number: PropTypes.number,
    purchasedAt: PropTypes.string,
  }),
};

export default ExpandedRowContent;
